'use client';
import PropTypes from 'prop-types';
import * as React from 'react';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';
import { useModalDialogContext } from './modal-dialog.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { className } from '../../../core/utilities/classnames.utils.js';
import { Button } from '../button/button.component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const propTypes = {
    /**
   * Specify the node or element that should be used for screen readers.
   */ visuallyHiddenLabel: PropTypes.node,
    /**
   * Provide the text that should be used for screen readers.
   */ accessibleText: PropTypes.string
};
/**
 * @subcomponent Dialog
 */ const ModalDialogCloseButton = renderWithRef('ModalDialogCloseButton', propTypes, (props, ref)=>{
    const { handleModalCloseButton } = useModalDialogContext();
    // discarding children
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { visuallyHiddenLabel, accessibleText, onClick, className: appliedClasses, children: _children } = props, restProps = _object_without_properties(props, [
        "visuallyHiddenLabel",
        "accessibleText",
        "onClick",
        "className",
        "children"
    ]);
    const accessibleNode = accessibleText !== null && accessibleText !== void 0 ? accessibleText : visuallyHiddenLabel;
    const classNames = className('swan-modal-dialog-close-button', appliedClasses);
    return /*#__PURE__*/ React.createElement(Button, _object_spread_props(_object_spread({
        skin: "tertiary",
        buttonShape: "round",
        className: classNames,
        ref: ref
    }, restProps), {
        onClick: composeEventHandlersUtil(onClick, handleModalCloseButton)
    }), accessibleNode !== null ? /*#__PURE__*/ React.createElement(VisuallyHidden, null, accessibleNode) : null, /*#__PURE__*/ React.createElement(Icon, {
        iconType: "close",
        size: "standard"
    }));
});

export { ModalDialogCloseButton };
